import { useEffect, useState } from 'react';
import { useAppSelector } from '../reducer/hooks';
import { selectProfile } from '../reducer/profileSlice';
import { ensureAccessToken } from '../api/axiosInstance';

function useToken() {
  const profile = useAppSelector(selectProfile);
  const isLogin = profile.isLogged;
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isLogin) {
      return;
    }

    async function fetch() {
      const isTokenValid = await ensureAccessToken();
      if (isTokenValid) {
        setIsReady(true);
      }
    }
    fetch();
  }, [isLogin]);

  return isReady;
}

export default useToken;
